import { Link } from 'react-router-dom';
import './productInfoCard.css';
import { useContext } from 'react';
import { cartContext } from '../App';

export default function ProductInfoCard(props) {

    const { CartItem, addToCart, removeFromCart, changeMaxAmountReached, extraData, clearAppliedCoupon } = useContext(cartContext);

    //time to deliver
    const now = new Date()
    const hours = Number(now.getHours())
    const min = Number(now.getMinutes()) / 60
    const current = hours + min
    const start = Number(extraData.data.startTime.split(':')[0]) + Number(extraData.data.startTime.split(':')[1])/60
    const end = Number(extraData.data.endTime.split(':')[0]) + Number(extraData.data.endTime.split(':')[1]) / 60
    // const start = 13
    // const end = 19
    const startTime = Number(extraData.data.startTime.split(':')[0]) > 12 ? Number(extraData.data.startTime.split(':')[0] - 12) + ' PM' : Number(extraData.data.startTime.split(':')[0]) + ' AM'

    function handleIncrement(index, data) {

        const currentItem = CartItem.find(productItem => productItem.id === data.id)
        if (currentItem) {
            const addData = {
                id: currentItem.id,
                details: currentItem.details,
                qty: currentItem.qty + 1
            }
            removeFromCart(addData);
            addToCart(addData)
        } else {
            const addData = {
                id: data.id,
                details: data.data,
                qty: 1
            }
            removeFromCart(addData);
            addToCart(addData)
        }  
        clearAppliedCoupon();
    }

    function handleDecrement(index, data) {
        const currentItem = CartItem.find(productItem => productItem.id === data.id)
        if (currentItem && currentItem.qty > 1) { 
            const addData = {
                id: currentItem.id,
                details: currentItem.details,
                qty: currentItem.qty - 1
            }
            removeFromCart(addData);
            addToCart(addData)
        } else {
            const addData = {
                id: currentItem.id,
                details: currentItem.details,
                qty: 0
            }
            removeFromCart(addData)
        }
        clearAppliedCoupon();
    }

    //handle maximum amount
    function handleMaximumAmount() {
        changeMaxAmountReached(true);
    }
    
    return (
        props.dataList.map((data, index) => (
            <div key={index} className="card">
                <Link to={`/product?productId=${data.id}&index=${index}`}>
                {
                    data.data.quantity > 0 ?
                        <div className='image-container'>
                            <img src={data.data.images[0]} alt="product pic" className="image_pic" />
                            {
                                data.data.discount > 0 && 
                                <span className='discount'>{data.data.discount}% OFF</span>    
                            }
                        </div> :
                        <div className='image-container' style={{ opacity: '0.4' }}>
                            <span className='sold-out'>sold out</span>
                            <img src={data.data.images[0]} alt="product pic" className="image_pic" />
                            {
                                data.data.discount > 0 && 
                                <span className='discount'>{data.data.discount}% OFF</span>    
                            }
                        </div>
                    }
                </Link>
                {/* {console.log('proudct info card se: ', data)} */}
                <Link to={`/product?productId=${data.id}&index=${index}`} className='title-name'>{ data.data.title }</Link>
        
                <p className='product-weights'>{data.data.weight}</p>

                {/* {
                    current >= start && current <= end &&
                    <div style={{display:'flex', flexDirection:'row', alignItems:'baseline', margin:'5px 0 5px 0'}}>
                        <img src='/icons/thunderbolt.png' alt='thunderbolt-logo' style={{height:'8px', width:'10px', margin:'0 0 0 2px'}}/>
                        <p className='delivery-time' style={{color:'green', fontSize:'10px', margin:'0', backgroundColor:'rgb(237, 243, 234)', padding:'2px', borderRadius:'5px'}}>{extraData.data.deliveryTime} mins</p>
                    </div>
                } */}

                {
                    start === end ? (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '5px 0 5px 5px' }}>
                            <p className='delivery-time' style={{ color: 'gray', fontSize: '10px', margin: '0', backgroundColor: 'rgb(237, 243, 234)', padding: '2px', borderRadius: '5px' }}>Unavailable Today</p>
                        </div>
                    ): (
                        current > end ?
                            (    
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '5px 0 5px 5px' }}>
                                    <img src='/icons/fast-delivery.png' alt='fast-delivery' style={{height:'10px'}} />
                                    <p className='delivery-time' style={{color:'green', fontSize:'10px', margin:'0', backgroundColor:'rgb(237, 243, 234)', padding:'2px', borderRadius:'5px'}}>{startTime}, Tommorrow</p>
                                </div>
                            ) :
                            (
                                current < start ?
                                    (
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '5px 0 5px 5px' }}>
                                            <img src='/icons/fast-delivery.png' alt='fast-delivery' style={{height:'10px'}} />
                                            <p className='delivery-time' style={{color:'green', fontSize:'10px', margin:'0', backgroundColor:'rgb(237, 243, 234)', padding:'2px', borderRadius:'5px'}}>{startTime}, Today</p>
                                        </div>
                                    ) :
                                    (
                                    <>
                                        <div style={{display:'flex', flexDirection:'row', alignItems:'baseline', margin:'5px 0 5px 0'}}>
                                            <img src='/icons/thunderbolt.png' alt='thunderbolt-logo' style={{height:'8px', width:'10px', margin:'0 0 0 2px'}}/>
                                            <p className='delivery-time' style={{color:'green', fontSize:'10px', margin:'0', backgroundColor:'rgb(237, 243, 234)', padding:'2px', borderRadius:'5px'}}>{extraData.data.deliveryTime} mins</p>
                                        </div>
                                    </>
                                    )
                            )
                    )
                        
                }

                <div className='card-bottom'>
                    <div className='prices'>
                        <p className='card-actual-price'><span style={{fontFamily:'Arial'}}>&#8377;</span>{Math.round(data.data.price * (100 - data.data.discount) / 100)}</p>
                        {
                            data.data.discount > 0 &&
                                <p className='card-price'><span style={{fontFamily:'Arial'}}>&#8377;</span>{data.data.price}</p>
                        }
                    </div>
                    {
                        Number(data.data.quantity) > 0 ? (
                            (() => {
                                const matching = CartItem.find((datas) => datas.id === data.id);
                                return matching ? (
                                    <div className='qty-card-box'>
                                        <button className='card-button-added' id={index} onClick={() => handleDecrement(index, data)}>-</button>
                                        <span className='qty-item'>{matching.qty}</span>
                                        {
                                            matching.qty >= data.data.quantity ?
                                                <button className='card-button-added' id={index} style={{ color:'gray'}} onClick={handleMaximumAmount}>+</button> :
                                                <button className='card-button-added' id={index} onClick={() => handleIncrement(index, data)}>+</button>
                                        }     
                                    </div>
                                ) :
                                <button className='card-button' id={index} onClick={() => handleIncrement(index, data)}>ADD</button>
                            })())
                            :
                            <button className='card-button' id={index} style={{backgroundColor: 'gray', color:'white'}} >Sold</button>
                    }
                </div>    
            </div>
        ))
    );
};
